import { wanjianshiLogoUrl, wanjianshiMarkUrl } from '@wanjianshi/brand-assets';

export const wanjianshiBrandAssets = {
  faviconUrl: wanjianshiMarkUrl,
  logoUrl: wanjianshiLogoUrl,
} as const;
